export default {"src":"/_next/static/image/public/images/menu_tele_consult.28f0b574b7348a3e8f64f2394456f4ef.svg","height":47,"width":47};